import { useState } from 'react';

import { UsersAvatarList } from '@hivebrite/design-system/UsersAvatarList';

import UsersModal from 'hb-react/shared/components/DesignSystem/UsersModal';
import useGroupNavigationTheme from 'hb-react/shared/hooks/theme/useGroupNavigationTheme';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';
import ThemeProvider from 'hb-react/style/ThemeProvider';

const Members = ({ topicId, users, totalUsers }) => {
  const groupNavigationTheme = useGroupNavigationTheme();
  const { flagEvUserPicturesToGlobalStorage } = useFeatureFlag();

  const [isModalOpened, setIsModalOpened] = useState(false);

  const showModal = (event) => {
    event?.stopPropagation();
    setIsModalOpened(true);
  };
  const hideModal = (event) => {
    event?.stopPropagation();
    setIsModalOpened(false);
  };

  if (!users?.length) {
    return null;
  }

  return (
    <>
      <UsersAvatarList
        imgSize={40}
        users={users.map(
          ({
            id,
            name,
            photo_thumb_url: photoThumbUrl,
            new_photo: newPhoto,
          }) => ({
            id,
            name,
            photo_thumb_url: flagEvUserPicturesToGlobalStorage
              ? newPhoto?.medium_url
              : photoThumbUrl,
          }),
        )}
        maxAvatars={4}
        totalUsers={totalUsers}
        onClickMore={showModal}
        screenReadersListTitle={s__('Accessibility|Group Members')}
        screenReadersMoreButtonText={s__(
          'Accessibility|Open an overlay to view all group members',
        )}
      />
      {isModalOpened ? (
        <ThemeProvider theme={groupNavigationTheme.themeName}>
          <UsersModal
            onCloseModal={hideModal}
            title={I18n.t('web.topics.followers.other')}
            routes={{
              fetchUsers: Routes.topics_topic_followings_path(topicId),
            }}
            responseCallback={(response) => ({
              users: response.followings.map((following) => following.user),
              total: response.total,
            })}
            screenReadersCloseButtonText={s__(
              'TopicsAccessibility|Close the topic followers list window',
            )}
          />
        </ThemeProvider>
      ) : null}
    </>
  );
};

export default Members;
